import { useLanguage } from "@/lib/i18n";

const content = {
  fr: [
    { value: "25+", label: "Détaillants canadiens pris en charge" },
    { value: "100 %", label: "Gratuit sur iPhone et Android" },
    { value: "FR · EN", label: "Disponible en français et en anglais" },
    { value: "🍁", label: "Conçu au Canada, pour les Canadiens" },
  ],
  en: [
    { value: "25+", label: "Canadian retailers supported" },
    { value: "100%", label: "Free on iPhone and Android" },
    { value: "FR · EN", label: "Available in English and French" },
    { value: "🍁", label: "Made in Canada, for Canadians" },
  ],
};

export function SocialProofBar() {
  const { language } = useLanguage();
  const stats = content[language];

  return (
    <section className="relative bg-secondary/30 border-y border-border">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6 max-w-5xl mx-auto">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className={`text-center animate-fade-up stagger-${index + 1}`}
            >
              <p className="font-heading text-3xl sm:text-4xl font-bold text-gradient mb-1.5">
                {stat.value}
              </p>
              <p className="text-sm text-muted-foreground leading-snug max-w-[200px] mx-auto">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
